/**
 * Der Abbau der vorigen Dokumente. Alle teilen **einen** Worker (`workerPort`), und pdf.js wirft,
 * wenn ein neues Dokument ihn anfordert, während ein altes ihn noch abbaut („PDFWorker.fromPort -
 * the worker is being destroyed"). Getroffen hat es den zweiten Klick auf **dieselbe** Datei: Ihre
 * Bytes kommen aus dem Zwischenspeicher, das neue Dokument startet ohne Netzpause, also mitten im
 * Abbau des alten — und der Betrachter meldete „konnte nicht geladen werden" (06.10.2026).
 */
let teardown: Promise<unknown> = Promise.resolve();

/** Ein Dokument abbauen; das nächste wartet darauf (`whenPdfWorkerIdle`). */
export const releasePdfDocument = (loadingTask: { destroy: () => Promise<unknown> } | null | undefined): void => {
    if (!loadingTask) return;
    const done = loadingTask.destroy().catch(() => undefined);
    teardown = Promise.all([teardown, done]);
};

/** Erst wenn kein Abbau mehr läuft, darf ein neues Dokument den Worker anfordern. */
export const whenPdfWorkerIdle = (): Promise<unknown> => teardown;
